import { useTranslation } from "react-i18next";
import { ContactForm } from "../../components/ContactForm";
import styles from "./Contacs.module.scss";

export const Contacts: React.FC = () => {
  const { t } = useTranslation();
  return (
    <>
      <div className={styles.textBlock}>
        <div className={styles.textBlockContainer}>
          <h1 className={styles.title}>{t("contact.contactUs")}</h1>
          <div>
            <p className={styles.descWrap}>{t("contact.descriptionOne")}</p>
            <p className={styles.descWrap}>{t("contact.descriptionTwo")}</p>
            <p className={styles.descWrap}>{t("contact.descriptionThree")}</p>
          </div>
        </div>
      </div>

      <div className={styles.contactFormWrapper}>
        <div className={styles.contactFormWrapperContainer}>
          <ContactForm />
        </div>
      </div>
    </>
  );
};
